import BigNumber from 'bignumber.js';

/**
 * 掩码地址
 */
interface MaskAddressProps {
  address: string;
  before?: number;
  after?: number;
  mark?: string;
}
export const maskAddress = (params: MaskAddressProps) => {
  const { address, before = 6, after = 4, mark = '..' } = params || {};
  if (!address) return address;

  return `${address.slice(0, before)}${mark}${address.slice(-after)}`;
};

/**
 * 添加千分符
 */
export const addCommas = (num: string | number) => {
  const [int, float] = BigNumber(num).toString().split('.');
  if (float) {
    return int.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + '.' + float;
  }
  return int.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export async function hashSHA256(message) {
  const encoder = new TextEncoder();
  const data = encoder.encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}

/**
 * 将字符串金额转换为数字表示,并处理错误情况
 * @param amount 单个或多个金额字符串
 * @returns 格式化后的金额字符串,格式为 $xxx,xxx
 */
export const formatAmountSum = (...amounts: string[]): string => {
  try {
    const sum = amounts.reduce((acc, amount) => {
      const num = Number(amount);
      return acc + (isNaN(num) ? 0 : num);
    }, 0);

    return `$${sum.toLocaleString()}`;
  } catch (error) {
    return '$0';
  }
};
